import { AlertItemQualifier } from "./alert-item-qualifier.model";
import { AlertItemUser } from "./alert-item-user.model";

export class AlertItemSupplemental {
  readonly createdBy: AlertItemUser;
  readonly qualifiers: AlertItemQualifier[];

  constructor(options: {
    createdBy: AlertItemUser;
    qualifiers: AlertItemQualifier[];
  }) {
    this.createdBy = options.createdBy;
    this.qualifiers = options.qualifiers;
  }
}
